export const AVERAGE_CATALOG_OPEN_REVIEW_MESSAGE =
  "This catalog is still used on Averages. Finish review there first.";

export const tournamentNamesFromCatalogLinks = (ids, tournaments) =>
  (ids || []).map((id) => {
    const match = (tournaments || []).find((row) => row.id === id);
    const name = String(match?.name || "").trim();
    return name || "a tournament";
  });

export const tournamentHasOpenAveragesReview = ({
  activeBowlerIds = [],
  averages = [],
}) => {
  const ids = [...new Set((activeBowlerIds || []).map(String))];
  if (!ids.length) return false;
  const verified = new Set(
    (averages || [])
      .filter((state) => state.isVerified)
      .map((state) => String(state.entityId))
  );
  return ids.some((id) => !verified.has(id));
};

export const tournamentNamesBlockingCatalogDelete = ({
  tournaments = [],
  teams = [],
  averages = [],
}) => {
  const bowlersByTournament = new Map();
  (teams || []).forEach((team) => {
    const tournamentID = team.squads?.tournamentID;
    if (!tournamentID) return;
    const current = bowlersByTournament.get(tournamentID) || [];
    (team.teamassignments || []).forEach((assignment) => {
      if (assignment.bowlerID) current.push(assignment.bowlerID);
    });
    bowlersByTournament.set(tournamentID, current);
  });

  const averagesByTournament = new Map();
  (averages || []).forEach((state) => {
    const tournamentID = state.tournamentId;
    if (!tournamentID) return;
    const current = averagesByTournament.get(tournamentID) || [];
    current.push(state);
    averagesByTournament.set(tournamentID, current);
  });

  const blockingIds = (tournaments || [])
    .filter((tournament) => !tournament.isDeleted)
    .filter((tournament) =>
      tournamentHasOpenAveragesReview({
        activeBowlerIds: [
          ...new Set(bowlersByTournament.get(tournament.id) || []),
        ],
        averages: averagesByTournament.get(tournament.id) || [],
      })
    )
    .map((tournament) => tournament.id);

  return tournamentNamesFromCatalogLinks(blockingIds, tournaments);
};

export const averageCatalogInUseMessage = (names) => {
  const labels = (names || [])
    .map((name) => String(name || "").trim())
    .filter(Boolean);
  if (labels.length === 0) {
    return AVERAGE_CATALOG_OPEN_REVIEW_MESSAGE;
  }
  if (labels.length === 1) {
    return `This catalog is still used on Averages for ${labels[0]}. Finish review there first.`;
  }
  if (labels.length === 2) {
    return `This catalog is still used on Averages for ${labels[0]} and ${labels[1]}. Finish review there first.`;
  }
  const rest = labels.length - 2;
  return `This catalog is still used on Averages for ${labels[0]}, ${labels[1]}, and ${rest} more. Finish review there first.`;
};

export class AverageCatalogInUseError extends Error {
  constructor(tournamentNames) {
    super(averageCatalogInUseMessage(tournamentNames));
    this.name = "AverageCatalogInUseError";
    this.tournamentNames = tournamentNames || [];
  }
}

export const isAverageCatalogOpenReviewError = (error) =>
  error instanceof AverageCatalogInUseError ||
  /still used on Averages/i.test(error?.message || "");
